import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery'; 
import 'datatables.net'; 
import swal from 'sweetalert';
import { ServerUrl } from '../../../../api/ServerUrl';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import { SetPermission } from '../../../../auth/SetPermission';

const BackImageList = () => {
  const { http } = ProtectAPi();
  const httpCPage = ServerUrl;
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const userPermission = SetPermission();

  useEffect(() => {
    http.get('/get-back-image-list')
      .then(res => { 
        setTableData(res.data);
      })
      .catch(error => {
        console.error('Error fetching back images:', error);
      });
  }, []);

  useEffect(() => {
    if (tableData.length > 0 && !tableRef.current.DataTable) {
      $(tableRef.current).DataTable();
    } else {
      if ($.fn.DataTable.isDataTable('#table-1')) {
        $(tableRef.current).DataTable().destroy();
      }
    }
  }, [tableData]);

  // const handleDeleteRole = (roleId) => {
  //   swal({
  //     title: 'Are you sure?',
  //     text: 'Once deleted, you will not be able to recover this item!',
  //     icon: 'warning',
  //     buttons: true,
  //     dangerMode: true,
  //   }).then((willDelete) => {
  //     if (willDelete) {
  //       http.delete(`/delete-back-image/${roleId}`)
  //         .then(response => {
  //           if (response.data.status !== 201) {
  //             setTableData(prev => prev.filter(data => data.id !== roleId));
  //           }
  //           swal(response.data.msg, {
  //             icon: response.data.alert,
  //           });
  //         })
  //         .catch(() => {
  //           swal('Oops! Something went wrong while deleting this item.', {
  //             icon: 'error',
  //           });
  //         });
  //     } else {
  //       swal('This item is safe!');
  //     }
  //   });
  // };

  return (
    <div>
      <div className="main-content">
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-3">
                      <h5>BG Image & SEO Info</h5>
                      {/* <div className="text-end">
                        <Link to='/admin/pages/background-image-add' className="btn btn-primary btn-md">
                          Add BG Image & SEO Info
                        </Link>
                      </div> */}
                    </div>
                    <div className="table-responsive">
                      <table className="table table-striped" id="table-1" ref={tableRef}>
                        <thead>
                          <tr>
                            <th className="text-center">#</th>
                            <th>Page Name</th>
                            <th>Image</th>
                            <th>Meta Title</th>
                            <th>OG Image</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((data, index) => (
                            <tr key={data.id}>
                              <td>{index + 1}</td>
                              <td>{data.page_name}</td>
                              <td>
                                <img
                                  alt=""
                                  src={`${httpCPage}/backend/img/back_image/${data.image}`}
                                  width="60"
                                />
                              </td>
                              <td>{data.meta_title || '—'}</td>
                              <td>
                                {data.og_image ? (
                                  <img
                                    src={`${httpCPage}/backend/img/back_image/${data.og_image}`}
                                    alt="OG"
                                    width="60"
                                  />
                                ) : '—'}
                              </td>
                              <td>
                                {userPermission.includes('image_edit') && (
                                  <Link to={`/admin/pages/background-image-edit/${data.id}`}>
                                    <button className="btn btn-warning">
                                      <i className="fas me-2 fa-edit text-white"></i>
                                    </button>
                                  </Link>
                                )}
                                {/* {userPermission.includes('home_delete') && (
                                  <button className="btn ms-2 btn-danger" onClick={() => handleDeleteRole(data.id)}>
                                    <i className="fas me-2 fa-trash text-white"></i>
                                  </button>
                                )} */}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BackImageList;
